/*
 * Module for the reviewing the selected KB settings as the last step of the KB wizard
 */

define([
  "backbone",
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbReview/kbReviewView",
], function (Backbone, $, Marionette, Messenger, KbReviewView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbReview";
      this.region = options.region;
    },
    show: function (kb) {
      this.kb = kb;
      this.layout = new KbReviewView.kbReviewLayout({ model: this.kb });

      this.contexts = this.kb.getContexts();
      this.touchPoints = this.kb.getTouchPoints();
      this.locales = this.kb.getLocales();

      this.tenants = Messenger.reqres.request("tenants");
      this.tenants.onSynced(function () {
        this.tenant = this.tenants.findWhere({ tenantId: this.kb.get("tenantId") });
        this.kb.tenantName = this.tenant.get("tenantName");
        this.buildReviewLists();
        this.layout.model = this.kb;
        this.showRegion(this.layout);
      }, this);
    },
    buildReviewLists: function () {
      //Builds the selected features, contexts, touchPoints, and locales as comma-separated lists to display
      const featureArr = [],
        contextArr = [],
        touchPointArr = [],
        localeArr = [];

      if (this.kb.get("taskManagement")) {
        featureArr.push($.t("admin.kbAdmin.taskManagement"));
      }
      if (this.kb.get("actionGroups")) {
        featureArr.push($.t("admin.kbAdmin.actions"));
      }
      if (this.kb.get("agentAssist")) {
        featureArr.push($.t("admin.kbAdmin.agentAssist"));
      }
      if (this.kb.get("adHocReporting")) {
        featureArr.push($.t("admin.kbAdmin.adHocReporting"));
      }
      if (this.kb.get("recommendations")) {
        featureArr.push($.t("admin.kbAdmin.recommendations"));
      }
      if (this.kb.get("crossTouchPointAccess")) {
        featureArr.push($.t("admin.kbAdmin.crossTouchPointAccess"));
      }
      if (this.kb.get("siteMapAccess")) {
        featureArr.push($.t("admin.kbAdmin.siteMapAccess"));
      }

      this.contexts.forEach(function (context) {
        contextArr.push(context.get("status"));
      }, this);
      this.touchPoints.forEach(function (touchPoint) {
        touchPointArr.push(touchPoint.get("touchPoint"));
      }, this);
      this.locales.forEach(function (locale) {
        localeArr.push(locale.get("name"));
      }, this);

      this.kb.featureList = featureArr.join(", ");
      this.kb.contextList = contextArr.join(", ");
      this.kb.touchPointList = touchPointArr.join(", ");
      this.kb.localeList = localeArr.join(", ");
    },
    getKb: function () {
      return this.kb;
    },
    isValid: function () {
      return true;
    },
  });
});
